import $ from "jquery";

(function($, window, document) {

	"use strict";
    
	/**
	 * Main theme object.
	*/
	var TLS_Product_menu = function () {
        var self = this;
		var that = this;
		var filtered = null;

        this.boot_ui = function () {
			//self.number_inputs();
			self.init_menu();
			self.init_days();
			self.filter_menu();
			self.filter_days();
		};

		this.init_days = function(){
			
			$('#menubox-days option').each(function(index, element) {
				if(index>0)
					return;

				$(this).prop('selected', true);

				let input = $(this).val();

				var bundle = $(".bundle_data")[0];
				self.set_dataset_menubox(bundle,input);				

			});

		};


		this.set_dataset_menubox = function(bundle,input) {
			let data = {};
				let type = '';
				// console.log(data);
				if (input == 'h5') {
					data.size_max = 10;
					data.size_min = 10;
					type = 'half';
				} else if (input == 'h7') {
					data.size_max = 14;
					data.size_min = 14;
					type = 'half';
				} else if (input == 'f5') {
					data.size_max = 15;
					data.size_min = 15;
					type = 'full';
				} else if (input == 'f7') {
					data.size_max = 21;
					data.size_min = 21;
					type = 'full';
				}
				// console.log(data);
				bundle.dataset.menubox_size = JSON.stringify(data);
				bundle.dataset.menubox_type = type;
		};


		this.filter_days = function(){
			$(document).on('change', '#menubox-days',function(e){
				e.preventDefault();
				let input = $(this).val();
				
				var bundle = $(".bundle_data")[0];
				self.set_dataset_menubox(bundle,input);
				
			});
		};

		this.init_menu = function () {

			// se non filtrato filtro la prima voce
			if(!self.filtered) {
				$('#tipo-menu a').each(function(index, element) {
					if(index>0)
						return;

					let link = $(element);
					let filter = link.data('tipo');
					filtered = filter;
					link.addClass('active');

					$('.bundled_products .bundled_product').each(function() {
						let product = $(this);
						let is_filter = product.hasClass('menu_' + filter);
						self.toggleProduct(product, is_filter);
					});
					
					
				});
			}
		};

        this.filter_menu = function () {

			$(document).on('click', '#tipo-menu a',function(e){
				e.preventDefault();
				$('#tipo-menu a').removeClass('active');
				let link = $(this);
				link.addClass('active');
				let filter = link.data('tipo');
				filtered = filter;
				$('.bundled_products .bundled_product').each(function() {
					let product = $(this)
					let is_filter = product.hasClass('menu_' + filter);
					self.toggleProduct(product, is_filter);
				});
			});
		};

		this.toggleProduct = function (product, is_filter) {
			if(is_filter) {
				product.removeClass('d-none')
			} else {
				product.addClass('d-none')
			}
		};

        
        
        this.bind = function () {
			$( document ).ready( self.boot_ui );
			// $( document ).ready( self.datePicker );
			// $( document ).ready( self.genderSelect );
			// $( document.body ).on( 'updated_wc_div', self.boot_ui );
			
		};

		
		this.init = function () {
			
			self.bind();
		};

		this.init();

	};

	(new TLS_Product_menu());
	
}(window.jQuery, window, document));